<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">   
      
	  <div class="backborder2 shop-sale-table">
	      <span class="shop-sales-title">线上商城销售数据环比图</span>
		  <el-form :inline="true" class="demo-form-inline" size="small" style="margin-top:10px">
		  	  <el-form-item style="width:10%">
				<el-select v-model="query.type" remote  filterable placeholder="时间类型" @change="changetimetype">
					<el-option v-for="(item,index) in typelist" :label="item.name" :value="item.id" :key="index" />
				</el-select>
			  </el-form-item>
			  <el-form-item style="width:20%" v-if="query.type==1">
					<el-date-picker	v-model="query.datedays" type="daterange" style="width:100%"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					value-format="yyyy-MM-dd" :unlink-panels="false" @change="query.ischange=true">
					</el-date-picker>
			  </el-form-item>
			  <el-form-item style="width:20%" v-if="query.type==2">
				  <el-button :type="query.dateweektype==1 ? 'primary' : '' " @click="changeweek(1)">最近一周</el-button>
				  <el-button :type="query.dateweektype==2 ? 'primary' : '' " @click="changeweek(2)">最近三周</el-button>
				  <el-button :type="query.dateweektype==3 ? 'primary' : '' " @click="changeweek(3)">最近七周</el-button>
			  </el-form-item>
			  <el-form-item style="width:10%" v-if="query.type==3">
					<el-date-picker	v-model="query.datemonths[0]" type="month" style="width:100%"
					placeholder="选择开始月份"
					value-format="yyyy-MM" :unlink-panels="false" @change="query.ischange=true">
					</el-date-picker>
			  </el-form-item>
			  <el-form-item style="width:10%" v-if="query.type==3">
					<el-date-picker	v-model="query.datemonths[1]" type="month" style="width:100%"
					placeholder="选择结束月份"
					value-format="yyyy-MM" :unlink-panels="false" @change="query.ischange=true">
					</el-date-picker>
			  </el-form-item>
			  <el-form-item style="width:12%">
				  <el-select v-model="query.brandid" filterable placeholder="按品牌" @change="query.ischange=true" clearable>
					  <el-option v-for="(item,index) in brandlists" :label="item.name" :value="item.brandid" :key="index"></el-option>
				  </el-select>
			  </el-form-item>

			  <el-form-item v-if="provincelists.length > 0">
					<el-select v-model="query.provinceid" filterable clearable placeholder="请选择省份" @change="changeprovince">	          
						<el-option v-for="(item,index) in provincelists" :label="item.showname" :value="item.id" :key="index">
								<span style="float: left;margin-right:10%;font-size: 13px">{{item.py}}</span>
								<span style="float: left">{{item.name}}</span>
						</el-option>
					</el-select>
			  </el-form-item>
				<el-form-item v-if="citylists.length > 0">
					<el-select v-model="query.cityid" filterable clearable placeholder="请选择城市" @change="query.ischange=true">	          
						<el-option v-for="(item,index) in citylists" :label="item.showname" :value="item.id" :key="index">
							<span style="float: left;margin-right:10%;font-size: 13px">{{item.py}}</span>
							<span style="float: left">{{item.name}}</span>
						</el-option>
					</el-select>
			  </el-form-item>
			  <el-form-item>
				  <el-input v-model="query.key" placeholder="店铺名 / 收货人 / 收货人电话" clearable/>
			  </el-form-item>
			  <el-form-item>
				  <el-button type="primary" circle icon="el-icon-search" @click="getmallsalecontact"/>
			  </el-form-item>
			  <el-form-item>
				  <template>
				  	  <div style="font-size:13px;color:#E6A23C">总销售额：<i style="font-style:normal;font-size:14px;font-weight:bold">￥{{contrastlists.allreals}}</i></div>
				  </template>
			  </el-form-item>
		  </el-form>
		  <div class="brand" style="margin-top:10px">
          	  <IEcharts :option="brand" :loading="custnaoLoading"/>
	  	  </div>
	  </div>

	  <!-- 贡献值 -->
	  <div class="backborder2 shop-sale-table" style="margin-top:10px;margin-bottom:20px" v-loading="query.loading" v-if="$cookies.get('agentid')==36">
	      <span class="shop-sales-title">店铺销售记录</span>
		  <table>
			<tr>
				<td class="shoptitle" align="center">店铺名称</td>
				<td class="shoptitle" align="center">联系方式</td>
				<td class="shoptitle" align="center">所在省份</td>
				<td class="shoptitle" align="center">销售金额</td>	
			</tr>
			<tr v-for="(item,index) in shoplists" :key="index">
				<td align="center">{{item.shopname}}</td>
				<td align="center">{{item.phone}}</td>
				<td align="center">{{item.provincename}} - {{item.cityname}}</td>
				<td align="center">{{item.allreals}}</td>
			</tr>
		  </table>
	      <div class="block">
	          <!--分页begin-->
	          <el-pagination
	              @size-change="salepageSizeChange"
	              @current-change="salepageCurrentChange"
	              :current-page="query.p"
	              :page-sizes="[10, 20, 50]"
	              :page-size="query.rollpage"
	              layout="total, sizes, prev, pager, next, jumper"
	              :total="shop_rows">
	          </el-pagination>
	          <!--分页end-->
	      </div>
	  </div>


  </div>
  </transition>  
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/full.js';
export default {
  data () {
    return {
        url:this.GLOBAL.domain+"Mallstat/index",
        transitionshow:true,
        actionauth:'', //功能权限
		typelist:[
			{id:1,name:'天'},
			{id:2,name:'周'},
			{id:3,name:'月'},
		],

		query: {
			act:'getmallsalecontrast',
			token:this.$cookies.get('token'),
			loading:false,
			ischange:false,
			type:1,
			brandid:'',
			datedays:[],
			dateweektype:1,
			datemonths:[],
			provinceid:'',
			cityid:'',
			key:'',
			p:1,
			rollpage:10
		},
		brandlists:[],
		provincelists:[],
		citylists:[],
		contrastlists:[],
		custnaoLoading:false,

		brand: {
          legend: {
			 data:['前一天销售额','当天销售额'],
			 show:false
		  },
		  dataZoom:[
            {
                type:'slider',//slider表示有滑动块的，inside表示内置的
                show:true,
                xAxisIndex:[0],
                start:0,
                end:100
            }
          ],
		  xAxis: {			  
			  type: 'category', //时间段
			  data: [], // x轴数据
			  name: '', //x轴名称
			  boundaryGap: true,
			  nameTextStyle: { //x轴名称样式
			    fontWeight: 600,
			    fontSize: 18,
				width: 20,
			  },
			  axisTick: {
                alignWithLabel: true
        	  },  
		  },
		  yAxis: {
				type: 'value',
				splitLine: { //去除网格线
					show:false,
				},
				name: '', //y轴名称
				nameTextStyle: { //y轴名称样式
					fontWeight: 400,
					fontSize: 13,
				},
		  },     
		  tooltip: {
			  trigger: 'axis' //axis item none三个值
		  },
		  
		  series: [
		  	  {
			    name: ['前一天销售额'],
			    data: [],
			    type: 'bar',
				barWidth : 40,
				barGap: 0,
			    itemStyle : {
					normal : {
						color:'#E6A23C',
					}
				},
				labelLine: {
					normal: {
						show: false
					}
				},
			  },

			  {
			    name: ['当天销售额'],
			    data: [],
			    type: 'bar',
				barWidth : 40,
				barGap: 0,
			    itemStyle : {
					normal : {
						color:'#67C23A',
					}
				},
				label: {
					normal: {
						show: true,
						position:'top',
						align:'center',
						formatter: function(v) {
							var val = v.data;
							if(val.type==1) return '{b|'+'今天：'+val.value+'}' + "\n" + '{a|'+'昨天：'+val.yesterday+'}' + '{c|'+ "\n"+"环比："+val.percent+ '%'+ (val.percent > 0 ? ' ↑ ' : ' ↓ ') +'}';
							if(val.type==2) return '{b|'+'本周：'+val.value+'}' + "\n" + '{a|'+'上周：'+val.yesterday+'}' + '{c|'+ "\n"+"环比："+val.percent+ '%'+ (val.percent > 0 ? ' ↑ ' : ' ↓ ') +'}';
							if(val.type==3) return '{b|'+'本月：'+val.value+'}' + "\n" + '{a|'+'上月：'+val.yesterday+'}' + '{c|'+ "\n"+"环比："+val.percent+ '%'+ (val.percent > 0 ? ' ↑ ' : ' ↓ ') +'}';
						},
						rich: {
							a: {
								color:'#333333',
								fontSize:12,
								lineHeight:18,
							},
							b: {
								color:'#333333',
								fontSize:12,
								lineHeight:18,
							},
							c: {
								color:'#333333',
								fontSize:12,
								lineHeight:18,
							}
						},
					}
				},
				labelLine: {
					normal: {
						show: false
					}
				},
			  }
		  ]
        },

		shoplists:[],
		shop_rows:0,


	}
  },

  components: {IEcharts},
  mounted(){    
    this.getactionauth();
	this.getBrand();
	this.getProvince(); //获取省份信息
	this.changequerytypestart();
  },
  
  methods:{
	
	/** 获取商城销售环比数据 **/
	getmallsalecontact() {
		if(this.query.ischange) {
			this.query.p=1;
			this.query.rollpage=10;
		}

		this.query.act='getmallsalecontrast';
		this.custnaoLoading=true;
		var resource = this.$resource(this.url);
	    resource.save(this.query).then((res) => {
		    if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.custnaoLoading=false;
		    }else{
		        this.contrastlists = JSON.parse(Base64.decode(res.data.Data));
				this.brand.xAxis.data=this.contrastlists.days;
				var _this=this;

				this.brand.legend.data=[];
				if(this.query.type==1) {
					this.brand.legend.data=['昨天','当天'];
					this.brand.series[0].name=['昨天'];
					this.brand.series[1].name=['当天'];
				}
				if(this.query.type==2) {
					this.brand.legend.data=['上周','本周'];
					this.brand.series[0].name=['上周'];
					this.brand.series[1].name=['本周'];
				}
				if(this.query.type==3) {
					this.brand.legend.data=['上月','本月'];
					this.brand.series[0].name=['上月'];
					this.brand.series[1].name=['本月'];
				}

				this.brand.series[0].data=[];
				this.brand.series[1].data=[];
				this.contrastlists.data.forEach(function(e,i) {
					_this.brand.series[0].data.push(e.yesterday);
					_this.brand.series[1].data.push(e);
				});

				var nums=this.contrastlists.days.length;
				if(nums <=12 ) {
					this.brand.dataZoom[0].start=0;
					this.brand.dataZoom[0].end=100;
				}else {
					var numbers=0;
					var numberlasts=0;
					this.brand.dataZoom[0].start=0;
					numbers=Number(nums/10);
					numberlasts=Number(nums%10 > 0 ? 1 : 0);
					this.brand.dataZoom[0].end=100/(numbers+numberlasts);
				}
		        this.custnaoLoading=false;

				//获取销售额贡献店铺信息列表
				this.getshopsales();

		    }
	    }).catch((res) => {
	        this.custnaoLoading=false;
	    });	
	},


	//获取店铺销售额贡献值
	getshopsales() {
		this.query.act='getmallshopsale';
		this.query.loading=true;
		var resource = this.$resource(this.url);
	    resource.save(this.query).then((res) => {
		    if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.query.loading=false;
		    }else{
		        this.shoplists = JSON.parse(Base64.decode(res.data.Data));
				this.shop_rows=parseInt(res.data.count);
		        this.query.loading=false;

		    }
	    }).catch((res) => {
	        this.query.loading=false;
	    });
	},


	salepageSizeChange(val) {
        this.query.rollpage = val;
        this.getshopsales();
    },
    salepageCurrentChange(val) {
        this.query.p = val;
        this.getshopsales();
    },






	//初始化类型
	changequerytypestart() {
		this.query.type=1;
		this.query.datedays=[];
		var date=new Date();
		this.query.datedays[1]=date.getFullYear().toString()+'-'+(date.getMonth()+1)+'-'+(date.getDate());
		date.setDate(date.getDate()-6);
		this.query.datedays[0]=date.getFullYear().toString()+'-'+(date.getMonth()+1)+'-'+(date.getDate());
		this.getmallsalecontact();
	},

	//修改查询时间梯度类型
	changetimetype() {
		this.query.ischange=true;
		if(this.query.type==1) { //时间梯度为天
			this.query.datedays=[];
			var date=new Date();
			this.query.datedays[1]=date.getFullYear().toString()+'-'+(date.getMonth()+1)+'-'+(date.getDate());
			date.setDate(date.getDate()-6);
			this.query.datedays[0]=date.getFullYear().toString()+'-'+(date.getMonth()+1)+'-'+(date.getDate());

		}else if(this.query.type==2) { //时间梯度为周
			this.query.dateweektype=3;

		}else if(this.query.type==3) { //时间梯度为月
			var date=new Date();
			this.query.datemonths[1]=date.getFullYear().toString()+'-'+(date.getMonth()+1)+'-'+(date.getDate());
			date.setMonth(date.getMonth()-5);
			this.query.datemonths[0]=date.getFullYear().toString()+'-'+(date.getMonth()+1)+'-'+(date.getDate());
		}
		
		this.query.brandid='';
		this.query.provinceid='';
		this.query.cityid='';
		this.query.key='';
		this.query.citylists=[];
		this.getmallsalecontact();
	},

	//修改选择周数
	changeweek(type) {
		this.query.ischange=true;
		this.query.dateweektype=type;
	},


	/////////////////////////////////////////////////////////////////////////////////////
	//初始化信息

	//获取功能权限
	getactionauth() {
		var data =this.$cookies.get('actionauth');
		data=JSON.parse(data);
		this.actionauth=data;
	},
	
	/** 获取品牌 **/
    getBrand(){
        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.brandlists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },

	/** 获取京东省份信息 **/
	getProvince() {
		var resource = this.$resource(this.GLOBAL.domain+"Product/index");	
	    resource.query({act:'getjdaddressinfosfromlocal',token:this.$cookies.get('token')}).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
			}else{
			    this.provincelists = JSON.parse(Base64.decode(res.data.Data));
			}
	    }).catch((res) => {
	        
	    });
	},

	/** 切换省份信息 **/
	changeprovince() {
		this.query.ischange=true;
		this.citylists=[];
		if(this.query.provinceid!='') {
			this.getcitylists();
		}
	},

	/** 获取省份信息列表 **/
	getcitylists() {
		if(this.query.provinceid=='') {
			this.query.cityid='';
			this.citylists=[];
			return false;
		}
		var resource = this.$resource(this.GLOBAL.domain+"Product/index");	
	    resource.query({act:'getjdaddressinfosfromlocal',parentid:this.query.provinceid,token:this.$cookies.get('token')}).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
			}else{
			    this.citylists = JSON.parse(Base64.decode(res.data.Data));
			}
	    }).catch((res) => {
	        
	    });
	},
	

   } 
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.shop-sale-table {padding:1% 1% 1% 1% !important;}
.shop-sale-table table {width:100%;border-radius:5px;border-collapse:collapse;border-spacing:0;border-left:1px solid rgb(221,221,221,.6);border-top:1px solid rgb(221,221,221,.6);margin-top:10px}
.shop-sale-table table td {border-right:1px solid rgb(221,221,221,.6);border-bottom:1px solid rgb(221,221,221,.6);font-size:13px;padding:10px 15px;color:#606266;}
.shop-sale-table table .shoptitle {background:rgb(221,221,221,.3);font-weight:600}
.shop-sales-title {width:100%;font-size:13px;color:#606266;margin-bottom:10px;}
.brand {width:100%;height:400px;margin-top:10px}
</style>


// WEBPACK FOOTER //
// src/components/mall/mallsalechart.vue